import { Chart as ChartJS, ChartConfiguration } from "chart.js";

export interface ChartMixinData {
  chart: ChartJS | null;
  isRendering: boolean;
  hasPendingRender: boolean;
}

export const chartMixin = {
  data(): ChartMixinData {
    return {
      chart: null,
      isRendering: false,
      hasPendingRender: false,
    };
  },
  methods: {
    destroyChart(this: any): void {
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
    },
    createOrUpdateChart(
      this: any,
      ctx: CanvasRenderingContext2D | HTMLCanvasElement,
      config: ChartConfiguration
    ): void {
      this.destroyChart();
      this.chart = new ChartJS(ctx, config);
    },
  },
  beforeDestroy(this: any): void {
    this.destroyChart();
  },
};
